import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  align-items: center;
  justify-content: center;
`;

export const ContainerHours = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  height: 316px;
  overflow: auto;
  padding: 10px 0;
`;

